import ScrollBooster from "scrollbooster";

const SHADOW_ROOT = document.querySelector("#acc").shadowRoot;

class Tabs {
    isInitialized = false;

    constructor(root) {
        // Init nav
        this.initNavigation(root, root.querySelector("[data-acc-tab-navigation-outer]"));

        // Open first tab
        root.querySelector("[data-acc-tab-button]")?.click();
        this.isInitialized = true;
    }

    initNavigation(root, navigationOuter) {
        const navigation = navigationOuter.querySelector(".tab-navigation");
        const innerNav = navigation.querySelector(".nav-inner");
        const underline = navigation.querySelector(".nav-underline");
        const buttons = navigation.querySelectorAll("[data-acc-tab-button]");

        let isMoving = false;

        // Vertical scroll
        const scrollBooster = new ScrollBooster({
            viewport: navigation,
            content: innerNav,
            scrollMode: "transform",
            direction: "horizontal",
            emulateScroll: true,
            inputsFocus: false,
            onUpdate: () => {
                if (!scrollBooster) {
                    return;
                }

                isMoving = Math.abs(scrollBooster.velocity.x) > 2;
            },
        });

        // Tabs
        let activeTab = null;
        buttons.forEach((button) => {
            const buttonKey = button.getAttribute("data-acc-tab-button");

            button.addEventListener("click", (e) => {
                if (isMoving || (activeTab === buttonKey)) {
                    return;
                }

                const innerNavBounding = innerNav.getBoundingClientRect();
                const buttonBounding = button.getBoundingClientRect();

                // Update underline styling
                underline.style.setProperty("width", `${buttonBounding.width}px`);
                underline.style.setProperty("left", `${buttonBounding.left - innerNavBounding.left}px`);

                // Toggle tab visibility
                SHADOW_ROOT.querySelector(`.acc [data-acc-tab="${buttonKey}"]`).style.setProperty('display', 'block');
                if(activeTab){
                    SHADOW_ROOT.querySelector(`.acc [data-acc-tab="${activeTab}"]`).style.setProperty('display', 'none');
                }

                // Scroll new tab into view
                if(this.isInitialized){
                    SHADOW_ROOT.querySelector(`.acc [data-acc-tab="${buttonKey}"]`).scrollIntoView({
                        behavior: 'smooth'
                    });
                }

                // Update active tab
                activeTab = buttonKey;

                // scrollBooster.scrollTo({
                //     y: 0,
                //     x: buttonBounding.left - innerNavBounding.left,
                // });
            });
        });

        // Sticky nav
        const spacer = root.querySelector('[data-acc-tab-navigation-spacer]');
        let state = 'top';

        document.addEventListener('scroll', () => {
            const rootBounding = root.getBoundingClientRect();
            const navHeight = navigationOuter.clientHeight;
            const outsideHeader = document.querySelector('.page-header.sticky-header');

            // Top Edge
            const topEdgeOffset = window.matchMedia('(min-width: 768px)').matches ? 0 : (outsideHeader ? outsideHeader.clientHeight : 0);

            let newState =  'top';
            if(rootBounding.bottom < topEdgeOffset + navHeight){
                newState = 'bottom';
            }else if(rootBounding.top < topEdgeOffset){
                newState = 'sticky';
            }

            if(state === newState){
                return;
            }

            state = newState;

            if(state === 'top'){
                navigationOuter.style.removeProperty('position');
                navigationOuter.style.removeProperty('top');
                navigationOuter.style.removeProperty('bottom');
                spacer.style.setProperty('display', 'none');
                spacer.style.removeProperty('height');
                return;
            }

            if(state === 'sticky'){
                navigationOuter.style.setProperty('position', 'fixed');
                navigationOuter.style.setProperty('top', `${topEdgeOffset}px`);
                navigationOuter.style.removeProperty('bottom');
                spacer.style.setProperty('display', 'block');
                spacer.style.setProperty('height', `${navHeight}px`);
                return;
            }

            if(state === 'bottom'){
                navigationOuter.style.setProperty('position', 'absolute');
                navigationOuter.style.removeProperty('top');
                navigationOuter.style.setProperty('bottom', '0px');
                spacer.style.setProperty('display', 'block');
                spacer.style.setProperty('height', `${navHeight}px`);
                return;
            }
        })
    }
}

const tabs = SHADOW_ROOT.querySelector("[data-acc-tabs]");

if (tabs) {
    new Tabs(tabs);
}
